export const MAX_CHECK_RETRIES_BEFORE_CONFIRM = 4;

export const SIGNALING_PING_TIMEOUT = 1_000;

export const BAD_NETWORK_SCORE = 2.6;

export const EXCELLENT_NETWORK_SCORE = 4.3;
